import React from 'react';
import "./index.css"
import { ContactForm } from './ContactForm';
import { StartYourProject } from '../Home/StartYourProject';
import { FAQSection } from './FAQSection';

export const ContactUs = () => {
  return (
    <div className='contactContainer'>
        <ContactForm/>
        <FAQSection/>
        <StartYourProject/>
    </div>
  )
}
